import React from 'react';
import './TableRowActions.scss';

export default ({ children }) => (
  <div className="component-table-row-actions">{children}</div>
);
